import { useEffect, useRef } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useAuth0Login } from "~/hooks/useAuth0Login";

export const Route = createFileRoute("/logout")({
  component: Logout,
});

function Logout() {
  const { logout } = useAuth0Login();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [logout]);

  return <div>Logging out...</div>;
}
